// eslint-disable-next-line no-shadow
export enum FormInputName {
  ticketPhysicalSaleId = 'ticketPhysicalSaleId',
  ticketPhysicalSaleDebit = 'ticketPhysicalSaleDebit',
  ticketPhysicalSaleCredit = 'ticketPhysicalSaleCredit',
  ticketPhysicalSalePix = 'ticketPhysicalSalePix',
  ticketPhysicalSaleAdministrateTax = 'ticketPhysicalSaleAdministrateTax',
  ticketPhysicalSaleInstallments = 'ticketPhysicalSaleInstallments',
  ticketPhysicalSaleFee = 'ticketPhysicalSaleFee',
  ticketWebsiteSaleId = 'ticketWebsiteSaleId',
  ticketWebsiteSaleBankSlip = 'ticketWebsiteSaleBankSlip',
  ticketWebsiteSaleCredit = 'ticketWebsiteSaleCredit',
  ticketWebsiteSalePix = 'ticketWebsiteSalePix',
  ticketWebsiteSaleAdministrateTax = 'ticketWebsiteSaleAdministrateTax',
  ticketWebsiteSaleInstallments = 'ticketWebsiteSaleInstallments',
  ticketWebsiteSaleFee = 'ticketWebsiteSaleFee',
  productPhysicalSaleId = 'productPhysicalSaleId',
  productPhysicalSaleDebit = 'productPhysicalSaleDebit',
  productPhysicalSaleCredit = 'productPhysicalSaleCredit',
  productPhysicalSalePix = 'productPhysicalSalePix',
  productPhysicalSaleAdministrateTax = 'productPhysicalSaleAdministrateTax',
  productPhysicalSaleInstallments = 'productPhysicalSaleInstallments',
  productPhysicalSaleFee = 'productPhysicalSaleFee',
  productWebsiteSaleId = 'productWebsiteSaleId',
  productWebsiteSaleBankSlip = 'productWebsiteSaleBankSlip',
  productWebsiteSaleCredit = 'productWebsiteSaleCredit',
  productWebsiteSalePix = 'productWebsiteSalePix',
  productWebsiteSaleAdministrateTax = 'productWebsiteSaleAdministrateTax',
  productWebsiteSaleInstallments = 'productWebsiteSaleInstallments',
  productWebsiteSaleFee = 'productWebsiteSaleFee',
}
